import * as currencies from "@/utils/currency/data.json";

export const defaultCurrency = currencies[0];

export const preferredCurrency = defaultCurrency;

export const allCurrencies = currencies;
